<template>
  <main-layout>
    <iframe
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allowfullscreen="true"
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        position: 'absolute',
        width: '100%',
        height: 'calc(100dvh - var(--nav-height))'
      }"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentLang', 'selectedBot']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/survey-iframe`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'open_external_link') {
        window.open(event.data.url, '_blank')
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      } else if (event.data.event_id === 'survey_redirect_to_all_in_one_chat') {
        const { search, app, inbox } = event.data.value
        let routeData = this.$router.resolve({
          name: 'livechat',
          path: '/' + this.currentLang + '/livechat',
          query: {
            userid: search,
            app: app,
            pageid: this.selectedBot.pageid
          }
        })
        if (this.selectedBot.features.includes('all-in-one-chat-new')) {
          routeData = this.$router.resolve({
            name: 'allinonechat-new',
            path: '/' + this.currentLang + '/allinonechat-new',
            query: {
              search: search,
              inbox: inbox,
              app: app
            }
          })
        }
        window.open(routeData.href, '_blank')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/SurveyIframe/index.vue